import * as React from 'react';
import { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import MenuButton from './MenuButton';
import MenuContent from './MenuContent';
import AlertVerifyEmail from './AlertVerifyEmail';
import { auth, logout } from '../../contexts/authentication';
import { Box, useColorScheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import logoCabanaWhite from '../images/logonextcabana-white.svg';
import logoCabanaBlack from '../images/logonextcabana-dark.svg';

interface SideMenuMobileProps {
  open: boolean | undefined;
  toggleDrawer: (newOpen: boolean) => () => void;
}

export default function SideMenuMobile({ open, toggleDrawer }: SideMenuMobileProps) {
  const { mode, systemMode } = useColorScheme();
  const currentUser = auth.currentUser;
  const [isEmailVerified, setIsEmailVerified] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser?.emailVerified) return;

    const interval = setInterval(async () => {
      await currentUser?.reload();
      if (!currentUser?.emailVerified) {
        clearInterval(interval);
        setIsEmailVerified(false);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [currentUser]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
        },
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          src={mode === 'dark' || systemMode === 'dark' ? logoCabanaWhite : logoCabanaBlack}
          alt="logo-cabanalink"
          style={{ width: '200px', height: 'auto', marginTop: '20px', marginBottom: '10px' }}
        />
      </div>
      <Stack
        sx={{
          maxWidth: '70dvw',
          height: '100%',
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack
            direction="row"
            sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              alt={currentUser?.displayName || 'Profile Picture'}
              src={currentUser?.photoURL}
              sx={{ width: 24, height: 24 }}
            />
            <Box sx={{ mr: 'auto' }}>
              <Typography component="p" variant="h6">
                {currentUser?.displayName}
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {currentUser?.email}
              </Typography>
            </Box>
          </Stack>
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent />
          <Divider />
        </Stack>
        {!isEmailVerified && <AlertVerifyEmail />}
        <Stack sx={{ p: 2 }} >
          <Button
            variant="outlined"
            fullWidth
            startIcon={<LogoutRoundedIcon />}
            onClick={() => {
              logout();
              navigate('/');
            }}
          >
            Sair
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}